<template>
    <div class="reserve-usage-history" v-if="Object.keys(reservation_node).length > 0">
      <ul class="reserve-usage-history__list">
        <li class="reserve-usage-history__lists" v-for="node in reservation_node" :key="node">
          <p class="reserve-usage-history__item d-flex align-items-center"><span class="reserve-usage-history__icon reserve-usage-history__icon--blue">完了</span><span class="reserve-usage-history__category">{{ node.label }}</span></p>
          <p class="reserve-usage-history__description">
            {{ node.start_date_str }} {{ youbi(node) }}
            <span v-for="item in node.item_data" :key="item">
                <!-- {{ item }} -->
                {{ item.start_time_str }} - {{ item.end_time_str }}/
            </span>
        </p>
        </li>
      </ul>
    </div>
    <div v-else>
        <p class="alert alert-info text-center">
            {{ word_chg('走行予約の履歴がありません。') }}
        </p>
    </div>
    <bs-page-nav :pager_sw="true" :load_pager_obj="pager_obj" :pager_key="'reservation_node'" @to_click_event="pageAction"></bs-page-nav>

</template>

<script>
import BsPageNav from '../../molecules/BsPageNav.vue'
import { mapState } from 'vuex';
import moment from 'moment'
import config from '../../../const'
import axios from 'axios'
import Common from '../../../common/common'
export default {
    name: 'ListReservedView',
    data: function () {
        return {
            pagelimit: 8,
            page: 0,
            reservation_node: [],
            pager_obj: {},
        }
    },
    props: {
        // displayClass: {
        //     type: String,
        //     default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        // },
    },
    components: {
        // BsPageTitle,
        BsPageNav
    },
    methods: {
        pageAction(page){
            console.log('pageAction', page);
            this.page = page;
            this.loadReservationNode();
        },
        async loadReservationNode () {
            const params = {};
            params['type'] = 'drive';
            // params['use_m_id'] = this.$store.state.auth.userId;
            params['stat'] = [1, 10];
            params['start_date_l'] = moment().subtract(1, 'd').format('YYYY-MM-DD');

            params['m_id_sql'] = JSON.stringify({
                'use_m_id': this.$store.state.auth.userId,
                'reservation_m_id': this.$store.state.auth.userId
            });
            params['pageorder'] = "(SELECT DATE_FORMAT(node_item_data.start_date, '%H%i%s') FROM node_item_data WHERE node_item_data.node_id = node_data.id ORDER BY node_item_data.start_date ASC LIMIT 1 OFFSET 0)";
            params['pagesort'] = 'ASC';
            params['pagelimit'] = this.pagelimit;
            if(this.page >= 0) params['p'] = this.page;

            const params_ = Common.createParams(params);
            axios.post(
                config.BASE_API_URL + '/reservation_node/lists',
                params_,
                {
                headers: this.axiosHeader
                }
            )
            .then(
                (response) => {
                    console.log('loadReservationNode response', response);
                    this.reservation_node = (response && response.data && typeof response.data === 'object' && typeof response.data.body === 'object')? response.data.body: [];
                    this.pager_obj = (response && response.data && typeof response.data === 'object' && typeof response.data.pager === 'object')? {reservation_node: response.data.pager}: {};
                }
            )
            .catch((err) => {
                console.log('loadDashboard err c', err);
                // this.search_sales = [];
                this.reservation_node = [];
            })
            .finally(() => {
                this.$forceUpdate();
            });

            // params['end_date'] = moment().format('YYYY-MM-DD');
            // return this.$store.dispatch('fetchBasicLists', {data: params, target: 'reservation_node'})
            //             .catch(err => Promise.reject(err))
            //             .then(() => {
            //                 console.log('loard complete reservation_node');
            //                 console.log('this', this.$store.state.apidata.reservation_node);
            //             })
            //             .finally(() => {
            //                 console.log('finally', this.$store.state.apidata.reservation_node);
            //             })
        },
    },
    computed: {
        ...mapState({
            // reservation_node: state => state.apidata.reservation_node,
            // paddock_list: state => state.apidata.drive_node_category,
        }),
        youbi: function (){
            return function(node){
                return moment(node.start_date_str).format("ddd");
            }
        },
        axiosHeader: function(){
            return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
        },
    },

    async created () {
        await this.loadReservationNode();
        // this.loaddriveNode();
        // this.loadLedgerType();
    },
}
</script>
